module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs10": ""
    }
  }, [(_vm.loadedNotice) ? _c('v-alert', {
    attrs: {
      "type": "warning",
      "dismissible": "",
      "timeout": _vm.timeout
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loadedNotice.noticeName) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/victorium_logo.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-card', {
      key: item.title,
      staticClass: "homeInfo",
      attrs: {
        "to": item.link
      }
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "light": ""
      }
    }, [_c('right-icon')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }))], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "alt pa-2",
    attrs: {
      "flat": "",
      "href": 'tel:210-639-2242'
    }
  }, [_c('phoneIcon', {
    staticClass: "icon",
    attrs: {
      "left": ""
    }
  }), _vm._v("\n        Call\n      ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "alt pa-2",
    attrs: {
      "flat": "",
      "href": 'mailto:test@test.com?subject=Get Help&body='
    }
  }, [_c('emailIcon', {
    staticClass: "icon",
    attrs: {
      "left": ""
    }
  }), _vm._v("\n        Email\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "alt pa-2 whyBtn",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n        Why Research? (PDF)\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64879220","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 692
// module chunks = 1